import React, { useContext, useState } from "react";

import { Button } from "../../Button";
import Link from "../../Link";
import CookieBannerGroup from "../CookieBannerGroup/CookieBannerGroup";

import GeneralPageContext from "../../../templates/GeneralPageContext";
import CookieContext from "../../CookieContext";

import translate from "../../../lib/translate";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import * as styles from "./component.module.less";
import {Headline} from "../../Headline";

export function CookieBanner({
    headline,
    intro,
    groups,
    settingsButton,
    declineButton,
    acceptAllButton,
    saveButton
}) {
    const {
        stdPages: { pageDataProtection }
    } = useContext(GeneralPageContext);

    const [mouseOut, setMouseOut] = useState(false);
    const { toggleSwitches } = useContext(CookieContext);
    const [currentPage, setCurrentPage] = useState("main"); // main and settings are reserved

    // const scrollPositionReached = useScrollHandler(100);

    const isMainPage = "main" === currentPage;
    const isSettingsPage = "settings" === currentPage;

    const SettingsButton = () => (
        <Button type="cta" onClick={() => setCurrentPage("settings")}>
            {settingsButton}
        </Button>
    );

    const DeclineButton = () => (
        <Button type="cta" onClick={() => toggleSwitches({ type: "decline" })}>
            {declineButton}
        </Button>
    );

    const AcceptAllButton = () => (
        <Button
            type="cta"
            onClick={() =>
                toggleSwitches({
                    type: "accept all",
                    keys: groups.map((group) => group.key)
                })
            }
            className={!isMainPage ? styles.fullwidthButton : ""}
        >
            {acceptAllButton}
        </Button>
    );

    const SaveButton = () => (
        <Button
            type="cta"
            onClick={() =>
                toggleSwitches({
                    type: "save"
                })
            }
            className={!isMainPage ? styles.fullwidthButton : ""}
        >
            {saveButton}
        </Button>
    );
    return (
        <div className={gcs(styles.cookieWrapper, styles.onScroll, [
            mouseOut,
            styles.delayedAnimation
        ])}
             onMouseEnter={() => setMouseOut(false)}
             onMouseLeave={() => setMouseOut(true)}>
            {isMainPage ? (
                <div className={styles.cookieContentWrapper}>
                    <div className={styles.cookieHeader}>
                        <Headline semanticOfHeadline={"H4 Style"} headlineClass={styles.noMargin}>{headline}</Headline>

                        {/* <a href="#">Policy</a> */}
                        <Link to={pageDataProtection?.url}>
                            {translate("cookie.policy-link")}
                        </Link>
                    </div>
                    <div className={styles.cookieContent}>{intro}</div>
                </div>
            ) : (
                <CookieBannerGroup
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    settingsTitle={settingsButton}
                    pages={groups}
                />
            )}
            <div className={styles.cookieButtonsWrapper}>
                {isMainPage && (
                    <>
                        <SettingsButton />

                        <DeclineButton />
                    </>
                )}

                {isSettingsPage && <SaveButton />}

                <AcceptAllButton />
            </div>
        </div>
    );
}
